<template>
    <div>
        <v-toolbar flat dense app color="primary" dark>
            <v-toolbar-side-icon @click.stop="drawer()"></v-toolbar-side-icon>
            <v-toolbar-title>Onus P/ Registrar</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="load">
                <v-icon>autorenew</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid  v-if="!caixas">
            <v-alert outline color="info" icon="autorenew" :value="true">
                Buscando Caixas
            </v-alert>
        </v-container>

        <v-container fluid  v-if="caixas && ! caixas.length">
            <v-alert outline color="success" icon="thumb_up" :value="true">
                Nenhuma ONU para registrar
            </v-alert>
        </v-container>

        <v-list two-line subheader v-if="caixas && caixas.length" style="margin-top: 10px">
            <template v-for="item in caixas" >
                <div :key="item.mac">
                    <v-list-tile avatar @click="goTo(item.mac)">

                        <v-list-tile-avatar>
                            <v-icon class="red" :class="[iconClass]">signal_wifi_off</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-sub-title>
                                <b>PON: {{ item.pon }} SLOT: {{ item.slot }}</b>
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                MAC: {{ item.mac}}
                            </v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn icon ripple>
                                <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-list-tile-action>

                    </v-list-tile>
                    <v-divider></v-divider>
                </div>
            </template>
        </v-list>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus.js"
    export default {
        name: "SubstituirCaixa",
        data () {
            return {
                search_text: null,
                iconClass: "white--text",
                search: false,
                caixas: null
            }
        },
        beforeMount () {
            this.load()
        },
        methods: {
            load () {
                Caixas
                    .unregistered()
                    .then(ordens => {
                        this.caixas = ordens.data.onus
                    })
                    .catch((err) => console.error(err))
            },
            drawer: () => {
                EventBus.$emit("drawer", true)
            },
            goTo (id) {
                this.$router.push("/substituir/caixa/" + id)
            }
        }
    }
</script>

<style scoped>

</style>
